export default {
    page_title: "Kevi | Relatório de Mensagens",
    title: "Mensagens",
    modal: {
        title: "Notificação",
    },
    stats: {
        total: "Mensagens",
        email: "E-mails",
        sms: "SMS",
        rcs: "RCS",
        whatsapp: "WhatsApp",
        oficial_whatsapp: "WhatsApp Oficial",
        accepted: "Aceitas",
        sent: "Enviadas",
        failed: "Falhas",
        scheduled: "Agendadas",
        queued: "Processando",
    },
    table: {
        message: "Mensagem",
        sender: "Disparador",
    },
    content: {
        subject_prefix: "Assunto: ",
    },
    filters: {
        automation: "Automação",
        sender: {
            label: "Disparador",
        },
        status: {
            label: "Situação",
            options: {
                accepted: "Aceita",
                scheduled: "Agendada",
                sent: "Enviada",
                failed: "Falha",
                queued: "Processando",
            },
        },
        method: {
            label: "Método",
            options: {
                email: "E-mail",
                sms: "SMS",
                rcs: "RCS",
                whatsapp: "WhatsApp",
                whatsapp_cloud: "WhatsApp Oficial",
            },
        },
    },
    actions: {
        retry_failed_aria: "Tentar reenviar mensagens com falha",
        retry_failed_tooltip: "Tentar novamente",
        cancel_scheduled_aria: "Cancelar mensagens agendadas",
        cancel_scheduled_tooltip: "Cancelar agendamento",
        view_email_body: "Ver corpo do Email",
    },
    confirmations: {
        retry_failed: "Deseja reenviar as {0} falhas agora?",
        cancel_scheduled: "Deseja realmente cancelar as mensagens agendadas?",
    },
    toasts: {
        retry_success: "Mensagens devolvidas à fila",
        cancel_success: "Mensagens canceladas",
    },
};
